import { render, staticRenderFns } from "./QuestionBankGameManager.vue?vue&type=template&id=823eb932&scoped=true&"
import script from "./QuestionBankGameManager.vue?vue&type=script&lang=js&"
export * from "./QuestionBankGameManager.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankGameManager.vue?vue&type=style&index=0&id=823eb932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823eb932",
  null
  
)

export default component.exports